import { FC } from 'react';
import { HStack } from '@chakra-ui/react';

import { ProviderPlanId } from '__generated__/GQL';
import ActivateInsuranceButton from 'features/Insurance/components/ActivateInsuranceButton';
import ClaimIntercomButton from 'features/Insurance/components/ClaimIntercomButton';
import { PlanTag } from 'features/Insurance/components/PlanTag';
import SimilarOffers from 'features/Insurance/components/SimilarOffers';
import {
  AssuredBy,
  Offer,
  OfferDetailsFromSource,
  OfferWithLink,
} from 'features/Insurance/types';
import * as Layout from 'layouts/OfferDetailsLayout';

import ContentWrapper from './components/ContentWrapper';

interface PageWrapperProps {
  from?: OfferDetailsFromSource;
  isCovered: boolean;
  isCoveredFromPlan: ProviderPlanId;
  backButtonLink: string;
  intercomMessage?: string;
  offerName: string;
  coverImage: string;
  offer: Offer;
  similarOffers: OfferWithLink[];
  pageName: string;
  assuredBy: AssuredBy;
  children: JSX.Element;
}

const PageWrapper: FC<PageWrapperProps> = ({
  assuredBy,
  backButtonLink,
  children,
  coverImage,
  from,
  intercomMessage,
  isCovered,
  isCoveredFromPlan,
  offer,
  offerName,
  pageName,
  similarOffers,
}) => {
  return (
    <Layout.PageContainer
      trackViewProps={{
        eventProperties: {
          from,
          offer: offerName,
        },
        pageName: pageName,
        usePrefix: false,
      }}
    >
      <Layout.BackButton to={backButtonLink} />

      <Layout.StickyHeader>
        <HStack gap="space-16">
          <Layout.HeaderTitle>{offer.title}</Layout.HeaderTitle>
          {isCovered === false ? <PlanTag plan={isCoveredFromPlan} /> : null}
        </HStack>

        {isCovered && intercomMessage ? (
          <ClaimIntercomButton
            intercomMessage={intercomMessage}
            offerName={offerName}
          />
        ) : null}

        {!isCovered ? <ActivateInsuranceButton offerName={offerName} /> : null}
      </Layout.StickyHeader>

      <Layout.Cover ratio={5.2} src={coverImage} />

      <ContentWrapper assuredBy={assuredBy} offer={offer} offerName={offerName}>
        {children}
      </ContentWrapper>

      <SimilarOffers offers={similarOffers} />
    </Layout.PageContainer>
  );
};

export default PageWrapper;
